module.exports = __webpack_public_path__ + "971364734f3b603e5d363a2634898b42.png";